import React from 'react'

type EllipsisCellProps = {
  children: React.ReactNode
  title?: string
  className?: string
}

/** Truncates long cell text with a native tooltip on hover. */
export const EllipsisCell: React.FC<EllipsisCellProps> = ({ children, title, className }) => {
  const text = children == null || children === '' ? '—' : children
  const tip = title ?? (typeof text === 'string' || typeof text === 'number' ? String(text) : undefined)

  return (
    <span className={['leap-table-ellipsis', className].filter(Boolean).join(' ')} title={tip}>
      {text}
    </span>
  )
}
